"use strict"

export function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
  "ngInject"

  var state
  return {
    // Add authorization token to headers
    request(config) {
      config.headers = config.headers || {}
      if ($cookies.get("token") && Util.isSameOrigin(config.url)) {
        config.headers.Authorization = `Bearer ${$cookies.get("token")}`
      }
      return config
    },

    // Intercept 401s and redirect you to login
    // Also handle rate limiter errors (503) for GemaPark API
    responseError(response) {
      if (response.status === 401) {
        ;(state || (state = $injector.get("$state"))).go("login")
        // remove any stale tokens
        $cookies.remove("token")
      }

      // Handle GemaPark rate limiter errors
      if (response.status === 503 && response.data && response.data.error) {
        // Check if this is a GemaPark API rate limit error
        if (response.data.error.includes("system is very busy") || response.data.error.includes("try again later")) {
          // Broadcast the error to show a user-friendly message
          $rootScope.$broadcast("gemapark-rate-limit", {
            message: response.data.error,
            activeSessions: response.data.activeSessions,
            maxSessions: response.data.maxSessions,
          })

          console.warn("GemaPark Rate Limit:", response.data.error)
        }
      }

      return $q.reject(response)
    },
  }
}
